import s from './Calibration.module.css';

export interface WarmupTask {
  id: string;
  label: string;
  status: 'pending' | 'running' | 'done' | 'error';
  detail?: string;
}

interface Props {
  tasks: WarmupTask[];
}

export function WarmupBar({ tasks }: Props) {
  const done = tasks.filter((t) => t.status === 'done').length;
  const pct = (done / tasks.length) * 100;
  return (
    <div className={s.warmup}>
      <div className={s.bar} aria-hidden>
        <div className={s.fill} style={{ width: `${pct}%` }} />
      </div>
      <ul className={s.tasks}>
        {tasks.map((t) => (
          <li
            key={t.id}
            className={s.task}
            data-status={t.status}
            aria-label={`${t.label} ${t.status}`}
          >
            <span className={s.tick} aria-hidden>
              {t.status === 'done' ? '●' : t.status === 'error' ? '×' : '○'}
            </span>
            <span className={s.taskLabel}>{t.label}</span>
            {t.detail ? <span className={s.taskDetail}>{t.detail}</span> : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
